import { useEffect, useState } from "react";

export default function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    setIsDesktop(window.innerWidth >= 1024);
    window.addEventListener("resize", () => {
      setIsDesktop(window.innerWidth >= 1024)
    });
    return () => {
      window.removeEventListener("resize", () => {
        setIsDesktop(window.innerWidth >= 1024)
      })
    }
  }, []);

  return isDesktop;
}